export default __webpack_public_path__ + "static/media/3d-rendering-seminar-meeting-banquet-hall-room (1).443d0aeb.jpg";